export default "__VITE_ASSET__BnrhBWUl__"